import(/* webpackMode: "eager" */ "/vercel/path0/app/(main)/our-work/koza/page.tsx");
